import { render, staticRenderFns } from "./Volleybal.vue?vue&type=template&id=54f756dd&scoped=true&"
import script from "./Volleybal.vue?vue&type=script&lang=ts&"
export * from "./Volleybal.vue?vue&type=script&lang=ts&"
import style0 from "./Volleybal.vue?vue&type=style&index=0&id=54f756dd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f756dd",
  null
  
)

export default component.exports